<template>
  <section class="page-dashbord-instructors pt-3">
    <app-loading :isFull="false" v-if="isLoading" />
    <div class="container">
      <div class="row">
        <div class="col">
          <header class="text-right mb-4">
            <h1 class="font-20">تعیین مدرس</h1>
          </header>
        </div>
      </div>
      <!-- @submit.prevent="submitForm" data-vv-scope="instructorsForm" -->
      <div class="wrapper-form shadow py-4 mb-5">
        <span class="row px-2" v-for="(items,index) in instructorsForm" :key="index">
          <div class="col-lg-4 col-12 mb-2" v-for="(item,i) in items" :key="i">
            <div class="group-form">
              <input
                type="text"
                v-validate="'required'"
                :name="item.name+index"
                :class="{active:item.model != ''}"
                v-model="item.model"
              />
              <span class="bar"></span>
              <label>{{item.label}}</label>
              <span v-if="errors.has(item.name+index)" class="is-danger">فیلد نباید خالی باشد</span>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="d-flex align-items-center mt-2">
              <button
                class="font-16 px-5 py-2 bttn-fill bttn bttn-warning"
                v-ripple
                @click="addNew"
                v-if="instructorsForm.length"
              >مدرس جدید +</button>
            </div>
          </div>
        </span>
        <p
          :class="['p-3 ', {'text-info' : percentageMode > 0 , 'text-danger' : percentageMode <= 0}]"
        >{{percentageMode}} % باقیمانده</p>
        <div class="col-12">
          <div class="d-flex align-items-center justify-content-end mt-2">
            <button
              class="font-16 px-5 py-2 bttn-fill bttn bttn-success"
              v-ripple
              @click="submitForm"
            >ذخیره</button>
          </div>
        </div>

        <controller-curose>
          <router-link
            to="/dashboard/sections"
            class="font-16 px-5 py-2 bttn-fill bttn bttn-primary"
            v-ripple
            v-if="instructorsForm.length"
          >رفتن به مرحله بعد</router-link>
        </controller-curose>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "page-dashbord-instructors",
  data() {
    return {
      isLoading: false,
      baseForm: [
        { name: "username", model: "", label: "نام کاربری مدرس" },
        { name: "percentage", model: "", label: "سهم مدرس  (درصد)" }
      ],
      instructorsForm: [
        [
          { name: "username", model: "", label: "نام کاربری مدرس" },
          { name: "percentage", model: "", label: "سهم مدرس  (درصد)" }
        ]
      ]
    };
  },
  computed: {
    percentageMode() {
      let list = [];
      this.instructorsForm.forEach(items => {
        list.push(...[items]);
      });
      list = list.map(item => {
        return Number(item[1].model);
      });
      let sum = 0;
      sum = Number(list.reduce((a, b) => a + b, 0));
      return 99 - sum;
    }
  },
  mounted() {
    if (localStorage && !this.hasCourse().id) {
      this.$root.showWarnMsg({
        message: "شما دوره ی جدیدی تعریف نکرده اید ..."
      });
      this.$router.push({ name: "courseForm" });
    } else {
      this.getInst();
    }
  },
  methods: {
    async getInst() {
      let { data } = await axios.post("/course-insts/get-for-edit", {
        course_id: this.hasCourse().id
      });
      if (data.instructors.length) {
        data.instructors.forEach(item => {
          this.instructorsForm.unshift([
            {
              name: "username",
              model: item.fullname,
              label: "نام کاربری مدرس"
            },
            {
              name: "percentage",
              model: item.percentage,
              label: "سهم مدرس  (درصد)"
            }
          ]);
        });
      }
    },
    async addNew() {
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.instructorsForm.push(...[this.baseForm]);
    },
    async submitForm() {
      if (this.percentageMode <= 0) {
        this.$root.showWarnMsg({
          message: "لطفا به درصد ها دقت کنید ... "
        });
        this.$root.showInfoMsg({
          message: "مجموع درصد ها  - 99 نباید کمتر از 0 باشد ... "
        });
        return;
      }
      let result = await this.$validator.validate();
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      let lastLenght = this.instructorsForm.length - 1;
      let username = this.instructorsForm[lastLenght][0].model;
      let percentage = this.instructorsForm[lastLenght][1].model;
      let { data } = await axios.post("/course-insts/check", {
        course_id: this.hasCourse().id,
        username: username
      });
      if (!data.user) {
        this.isLoading = false;
        this.$root.showWarnMsg({
          message: "نام کاربری در سیستم موجود نیست"
        });
        return;
      }
      this.isLoading = false;
      this.setInsts(percentage, data.user, lastLenght);
    },
    async setInsts(percentage, user, lastLenght) {
      this.isLoading = true;
      let { data } = await axios.post("/course-insts/set", {
        course_id: this.hasCourse().id,
        instructors: [
          {
            percentage: parseInt(percentage),
            user: user
          }
        ]
      });
      if (data.state !== 200) {
        this.$root.showWarnMsg({
          message: "مشکلی پیش آمده ..."
        });
        this.isLoading = false;
        return;
      }
      this.$root.showInfoMsg({
        message: "با موفقیت اضافه شد ... "
      });
      this.isLoading = false;
      // lastLenght
    }
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-instructorsForm {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/instructors.vue